import { apiClient } from './client';
export const authOrganizationApi = {
    async create(clientCompanyId, createDto) {
        return apiClient.post(`/api/ClientCompanies/${clientCompanyId}/AuthOrganizations`, createDto);
    },
    async getById(clientCompanyId, authOrganizationId) {
        return apiClient.get(`/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrganizationId}`);
    },
    async update(clientCompanyId, authOrganizationId, update, logoFile) {
        // Use multipart form when a file is present
        if (logoFile) {
            const formData = new FormData();
            // Keep JSON structure same key as create for consistency if server aligns later
            formData.append('authOrganizationData', JSON.stringify(update));
            formData.append('logo', logoFile);
            return apiClient.put(`/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrganizationId}`, formData);
        }
        return apiClient.put(`/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrganizationId}`, update);
    },
    async getOrgIdByEmail(email) {
        const encoded = encodeURIComponent(email.trim());
        return await apiClient.get(`/api/AuthOrganizations/resolve/org-id-by-email?email=${encoded}`);
    },
};
